export default __webpack_public_path__ + "static/media/create-account.569c1cb5.svg";